import React, { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { Icon } from "leaflet";
import { Link, useNavigate } from "react-router-dom";
import { LatLngBounds } from "leaflet";

// Component to automatically fit bounds
const FitBounds = ({ markers }) => {
  const map = useMap();
  
  React.useEffect(() => {
    if (markers && markers.length > 0) {
      const bounds = new LatLngBounds();
      markers.forEach(marker => {
        bounds.extend(marker.geocode);
      });
      map.fitBounds(bounds, { padding: [20, 20] });
    }
  }, [map, markers]);
  
  return null;
};

const UnitsMap = ({ StorageUnitData }) => {
  // Calculate dynamic zoom and center based on all facilities
  const mapConfig = useMemo(() => {
    if (!StorageUnitData || StorageUnitData.length === 0) {
      return { center: [40.7128, -74.0060], zoom: 8 }; // Default NYC
    }

    if (StorageUnitData.length === 1) {
      return {
        center: [StorageUnitData[0].location.lat, StorageUnitData[0].location.lon],
        zoom: 13
      };
    }

    // Calculate bounds for multiple facilities
    const lats = StorageUnitData.map(unit => unit.location.lat);
    const lons = StorageUnitData.map(unit => unit.location.lon);
    
    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
    const minLon = Math.min(...lons);
    const maxLon = Math.max(...lons);
    
    const centerLat = (minLat + maxLat) / 2;
    const centerLon = (minLon + maxLon) / 2;
    
    // Calculate appropriate zoom based on spread
    const latDiff = maxLat - minLat;
    const lonDiff = maxLon - minLon;
    const maxDiff = Math.max(latDiff, lonDiff);
    
    // Dynamic zoom calculation
    let zoom;
    if (maxDiff > 0.5) zoom = 6;      // Very spread out - country level
    else if (maxDiff > 0.2) zoom = 7;  // State level
    else if (maxDiff > 0.1) zoom = 8;  // City level
    else if (maxDiff > 0.05) zoom = 9; // Neighborhood level
    else if (maxDiff > 0.02) zoom = 10; // Local area
    else zoom = 11; // Very close facilities
    
    return {
      center: [centerLat, centerLon],
      zoom: zoom,
      useFitBounds: true // Flag to use bounds fitting
    };
  }, [StorageUnitData]);

  console.log("data is coming from map and chart ", StorageUnitData);
  console.log("Map config:", mapConfig);
  
  // create custom icon
  const customIcon = new Icon({
    iconUrl: "/images/location-pin.png",
    iconSize: [38, 38], // size of the icon
  });

  // markers
  const markers =
    StorageUnitData &&
    StorageUnitData.map((unit) => {
      return {
        geocode: [unit.location.lat, unit.location.lon],
        popUp: unit.storage_provider.name,
        link: `/service-provider-dashboard/storagefacilities/${unit.id}`,
        address: unit.location.address,
      };
    });

  return (
    <div style={{ borderRadius: '15px', overflow: 'hidden' }}>
    <MapContainer center={mapConfig.center} zoom={mapConfig.zoom} scrollWheelZoom={false} >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {markers && markers.length > 1 && <FitBounds markers={markers} />}
      {markers.map((marker, index) => (
        <Marker position={marker.geocode} key={index} icon={customIcon}>
          <Popup>
            <div className="text-center">
              <h3 className=" border-bottom">{marker.popUp}</h3>
              <p>{marker.address}</p>
              <Link className="btn btn-sm btn-dark text-dark" to={marker.link}>
                View details
              </Link>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
    </div>
  );
};

export default UnitsMap;
